/**
 * @generated SignedSource<<05ccbbe31e1bfe103b543479c7227439>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type OrderStatus = "CANCELED" | "DRAFT" | "EMPTY" | "FULLY_PAID" | "FULLY_REFUNDED" | "OPEN" | "PARTIALLY_PAID" | "PARTIALLY_REFUNDED";
import { FragmentRefs } from "relay-runtime";
export type packageOrderNeedsPayment_order$data = {
  readonly packageDueDate: string | null | undefined;
  readonly status: OrderStatus | null | undefined;
  readonly " $fragmentType": "packageOrderNeedsPayment_order";
};
export type packageOrderNeedsPayment_order$key = {
  readonly " $data"?: packageOrderNeedsPayment_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"packageOrderNeedsPayment_order">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "packageOrderNeedsPayment_order"
};

(node as any).hash = "f7843a6f5daa90ed0c51162bd2a56cc8";

export default node;
